import { gql, type TypedDocumentNode } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  DeleteTaskLineupMutation,
  DeleteTaskLineupMutationVariables,
} from './__generated__/useDeleteTaskLineup.graphql';

const DELETE_TASK_LINEUP_MUTATION = gql`
  mutation DeleteTaskLineupMutation($input: deleteTaskLineupInput!) {
    deleteTaskLineup(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  DeleteTaskLineupMutation,
  DeleteTaskLineupMutationVariables
>;

export const useDeleteTaskLineup = () => {
  return useMutation(DELETE_TASK_LINEUP_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
